import React from "react";
import Icon from "Components/Icons/Icon";
import "../../assets/scss/components/_user-detail.scss";
import CustomButton from "../Custom/CustomButton";

interface UserDetailsHeaderProps {
  name: string;
  avatar?: string;
  company: string;
  trade: string;
  email: string;
  phone: string;
  subscription: string;
  onImpersonate?: () => void;
  onDisable?: () => void;
  onRemove?: () => void;
  isDisabled?: boolean;
  isDisableLoading?: boolean;
}

const UserDetailsHeader: React.FC<UserDetailsHeaderProps> = ({
  name,
  avatar,
  company,
  trade,
  email,
  phone,
  subscription,
  onImpersonate,
  onDisable,
  onRemove,
  isDisabled,
  isDisableLoading,
}) => {
  return (
    <div className="user-header-card d-flex flex-wrap align-items-center p-4 mb-4 gap-3 gap-lg-0">
      {/* Left Section */}
      <div className="col-12 col-lg-8 d-flex flex-wrap  align-items-center gap-3 mb-0 mb-lg-0">
        <img
          src={avatar}
          alt={name}
          className="rounded-circle user-header-avatar"
        />

        <div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h5 className="user-name">{name}</h5>
            <span className="badge bg-light text-primary fw-medium py-2 px-3 fs-12">
              {subscription}
            </span>
          </div>

          <p className="text-black2D font-primary fw-normal fs-16 m-0">
            {company}
          </p>

          <div className="d-flex align-items-center gap-3 flex-wrap mt-2 text-grey89">
            <span className="d-flex align-items-center gap-1 text-grey89 fs-14 fw-normal font-primary">
              <Icon name="Profile" /> {trade}
            </span>
            <span className="text-greyE4">|</span>
            <span className="d-flex align-items-center gap-1 text-grey89 fs-14 fw-normal font-primary">
              <Icon name="Mail" style={{ marginTop: 2 }} /> {email}
            </span>
            <span className="text-greyE4">|</span>
            <span className="d-flex align-items-center gap-1 text-grey89 fs-14 fw-normal font-primary">
              <Icon name="PhoneUser" /> {phone}
            </span>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="col-12 col-lg-4 d-flex flex-column flex-lg-row gap-2 justify-content-lg-end user-button-actions">
        <CustomButton
          text="Impersonate"
          leftIcon={<Icon name="SearchW" />}
          className="bg-primary br-7 "
          onClick={onImpersonate}
        />
        <CustomButton
          text={isDisabled ? "Enable" : "Disable"}
          leftIcon={<Icon name="DisableW" />}
          className="bg-primary br-7 "
          onClick={onDisable}
          loading={isDisableLoading}
        />
        <CustomButton
          text="Remove"
          leftIcon={<Icon name="DeleteW" />}
          className="bg-primary br-7 "
          onClick={onRemove}
        />
      </div>
    </div>
  );
};

export default UserDetailsHeader;
